const _Dummy = (element) => {
  const main = () => {
    console.log("_Dummy: ", element);
  }

  main();
};

export default _Dummy;
